// Copyright Prashant Vaghela, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import { PropertyFilterProps } from '@cloudscape-design/components/property-filter';

export const propertyFilterI18nStrings: PropertyFilterProps.I18nStrings = {
  filteringAriaLabel: 'Find distributions',
  filteringPlaceholder: 'Find distributions',
};
